import { useEffect, useState } from "react";
import { getSettings } from "@/lib/api";

let cache = null;
let promise = null;

export function useSettings() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) { setData(cache); return; }
    if (!promise) promise = getSettings().then(d => { cache = d; return d; });
    promise.then(setData).catch(() => {});
  }, []);
  return data;
}

export function invalidateSettings() { cache = null; promise = null; }
